var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"m18.233 0-3.42 3.375L27.35 15.75H0v4.5h27.349L14.814 32.625 18.233 36l18.232-18z"}));
}

ArrowRight.defaultProps = {"fill":"none","viewBox":"0 0 37 36"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
